import * as types from './mutation-types'

// accion que determina el login de usuario
export const loginUser = ({ commit }, tokenUser) => {
  commit(types.LOGIN, tokenUser)
}
// accion para cambiar data usuario
export const setUser = ({ commit }, usuario) => {
  commit(types.SET_USER, usuario)
}

// accion para cambiar data usuario
export const logoutUser = ({ commit },) => {
  commit(types.LOGOUT)
}

// accion para cambiar data usuario
export const setImageUser = ({ commit }, image) => {
  commit(types.SET_IMAGE_USER, image)
}
